import { createContext, useContext, useEffect, useMemo, useState } from "react";

import io from "socket.io-client";
import { useSelector, shallowEqual } from "react-redux";
import {
  IS_PRODUCTION,
  SOCKET_URL,
  SOCKET_URL_DEV,
  URL_PRO,
} from "../../utils/constance";

// const SOCKET_URL = IS_PRODUCTION ? URL_PRO : SOCKET_URL_DEV;

const SocketContext = createContext(null);

const socket = io(SOCKET_URL, {
  autoConnect: false,
  // withCredentials: true,
  transports: ["websocket"],
  reconnection: true,
  reconnectionAttempts: 5,
  reconnectionDelay: 3000,
  timeout: 10000,
});

export const SocketProvider = ({ children }) => {
  const [isConnected, setIsConnected] = useState(false);

  const { token, LoggedInUserId } = useSelector(
    (state) => ({
      token: state.user.token,
      LoggedInUserId: state.user.user?.id,
    }),
    shallowEqual,
  );

  useEffect(() => {
    if (!token || !LoggedInUserId) return;

    socket.auth = { token };

    const onConnect = () => {
      console.log("socket connected:", socket.id);
      setIsConnected(true);
    };

    const onDisconnect = () => {
      console.log("socket disconnected");
      setIsConnected(false);
    };

    const onConnectError = (err) => {
      console.log("socket error:", err);
    };

    socket.on("connect", onConnect);
    socket.on("disconnect", onDisconnect);
    socket.on("connect_error", onConnectError);
    socket.on("session-expired", (data) => {
      // if (data.isSessionExpired) userLogout();
    });

    // connect socket
    socket.connect();

    // cleanup
    return () => {
      socket.off("connect", onConnect);
      socket.off("disconnect", onDisconnect);
      socket.off("connect_error", onConnectError);

      socket.disconnect();
    };
  }, [token, LoggedInUserId]);

  const value = useMemo(
    () => ({
      socket,
      isConnected,
    }),
    [isConnected],
  );

  return (
    <SocketContext.Provider value={value}>{children}</SocketContext.Provider>
  );
};

export const useSocket = () => {
  return useContext(SocketContext);
};
